const o = (e, t) => {
  typeof document < "u" && document.documentElement.style.setProperty(e, String(t));
};
export {
  o as setCustomCSSProperty
};
//# sourceMappingURL=setCustomCSSProperty.mjs.map
